function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#1F2331",
  d: "M25.494 12.749c2.008 1.185 2.008 4.09 0 5.275L4.619 30.344C2.578 31.547 0 30.076 0 27.706V3.067C0 .697 2.578-.775 4.62.43l20.874 12.319z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 27,
    height: 31,
    fill: "none",
    viewBox: "0 0 27 31"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/PlayButton.01bc98b2.svg";
export { SvgComponent as ReactComponent };